import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSession } from "@hooks/useSession";
import axios from "@api/axios";

const useEditData = (url, queryKey) => {
  const { token } = useSession();
  const queryClient = useQueryClient();

  const mutationFn = async (data) => {
    const response = await axios.put(url, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries(queryKey);
    },
  });
};

export default useEditData;
